import { CheckIcon, XMarkIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import RejectReasonPicker from "./RejectReasonPicker";

const Kbd = ({ children }) => (
  <kbd className="ml-1.5 rounded border border-white/30 px-1 text-[10px] font-normal opacity-80">{children}</kbd>
);

/** Модальдың төменгі жабысқақ панелі: шешім + келесі жарнамаға өту. */
export default function ModerationDetailBar({
  ad,
  position,
  total,
  onPrev,
  onNext,
  onAccept,
  onReject,
  rejecting,
  setRejecting,
  busy,
}) {
  if (!ad) return null;
  return (
    <div className="sticky bottom-0 z-40 border-t border-border-primary bg-bg-card/95 px-6 py-3 backdrop-blur">
      {rejecting ? (
        <RejectReasonPicker
          busy={busy}
          onCancel={() => setRejecting(false)}
          onConfirm={(msg) => onReject(ad.id, msg)}
          confirmLabel="Отклонить и дальше"
        />
      ) : (
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center gap-1">
            <button
              type="button"
              onClick={onPrev}
              disabled={!onPrev}
              className="rounded-lg p-2 text-text-secondary hover:bg-bg-tertiary disabled:opacity-30"
              title="Предыдущее (←)"
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <span className="min-w-[4.5rem] text-center text-sm text-text-muted">
              {position} из {total}
            </span>
            <button
              type="button"
              onClick={onNext}
              disabled={!onNext}
              className="rounded-lg p-2 text-text-secondary hover:bg-bg-tertiary disabled:opacity-30"
              title="Следующее (→)"
            >
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>
          <span className="hidden text-xs text-text-muted md:inline">A — принять · R — отклонить · ←/→ — листать · Esc — закрыть</span>
          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => setRejecting(true)}
              disabled={busy || ad.status === "rejected"}
              className="inline-flex items-center rounded-lg border border-rose-500/60 px-4 py-2 text-sm font-semibold text-rose-500 hover:bg-rose-500/10 disabled:cursor-not-allowed disabled:opacity-40"
            >
              <XMarkIcon className="mr-1.5 h-4 w-4" />
              Отклонить
              <Kbd>R</Kbd>
            </button>
            <button
              type="button"
              onClick={() => onAccept(ad.id)}
              disabled={busy || ad.status === "active"}
              className="inline-flex items-center rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-40"
            >
              <CheckIcon className="mr-1.5 h-4 w-4" />
              {busy ? "Сохраняем…" : "Принять и дальше"}
              <Kbd>A</Kbd>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
